const common = {
  "site.name": "KakobuyFinds",
  "site.tagline": "Najlepsze Kakobuy Spreadsheet dla Polaków",
  "nav.home": "Strona główna",
  "nav.categories": "Kategorie",
  "nav.shopping_guide": "Poradnik zakupowy",
  "nav.spreadsheet": "Kakobuy Spreadsheet",
  "nav.buy_now": "Kup teraz",
  "nav.article": "Poradnik",
  "hero.title": "Kakobuy Spreadsheet Polska – Znajdź najlepsze produkty szybciej",
  "hero.subtitle": "Największy przewodnik Kakobuy Spreadsheet dla polskich użytkowników. Odkrywaj najlepsze finds, sprawdzaj produkty, porównuj opcje i korzystaj z uporządkowanych list produktów.",
  "hero.cta_primary": "Przejdź do Kakobuy Spreadsheet",
  "hero.cta_secondary": "Zobacz najnowsze Finds",
  "trust.title": "Dlaczego warto korzystać z Kakobuy Spreadsheet?",
  "trust.card1.title": "Szybkie wyszukiwanie",
  "trust.card1.desc": "Gotowe listy produktów zamiast godzinnego szukania. Wszystko w jednym miejscu.",
  "trust.card2.title": "Sprawdzone produkty",
  "trust.card2.desc": "Łatwiejsze porównywanie ofert i dostęp do zweryfikowanych linków produktowych.",
  "trust.card3.title": "Kategorie produktów",
  "trust.card3.desc": "Sneakers, moda, akcesoria i wiele więcej – wszystko posegregowane i gotowe.",
  "trust.card4.title": "Bezpieczne zakupy",
  "trust.card4.desc": "Poradniki bezpieczeństwa i najlepsze praktyki zakupowe dla polskich użytkowników.",
  "stats.users": "Aktywnych użytkowników",
  "stats.products": "Produktów w bazie",
  "stats.categories": "Kategorii",
  "stats.satisfaction": "Zadowolonych klientów",
  "categories.title": "Przeglądaj kategorie produktów",
  "categories.subtitle": "Wybierz interesującą Cię kategorię i odkryj najlepsze Kakobuy Finds",
  "comparison.title": "Kakobuy Spreadsheet vs Standardowe wyszukiwanie",
  "comparison.feature": "Funkcja",
  "comparison.spreadsheet": "Kakobuy Spreadsheet",
  "comparison.standard": "Standardowe wyszukiwanie",
  "comparison.f1": "Gotowe produkty",
  "comparison.f2": "Kategorie",
  "comparison.f3": "Linki produktów",
  "comparison.f4": "Oszczędność czasu",
  "comparison.f5": "Porównanie ofert",
  "comparison.f6": "Aktualizacje",
  "comparison.yes": "✓",
  "comparison.no": "✗",
  "comparison.limited": "Ograniczone",
  "comparison.high": "Bardzo wysoka",
  "comparison.low": "Niska",
  "comparison.regular": "Regularne",
  "comparison.rare": "Rzadkie",
  "seo.title": "Kakobuy Spreadsheet – Kompletny przewodnik 2026",
  "article.read_more": "Przeczytaj pełny poradnik",
  "article.preview": "Dowiedz się wszystkiego o Kakobuy Spreadsheet – jak zacząć, jakie produkty warto kupić, porady dotyczące bezpieczeństwa i wysyłki do Polski. Kompletny przewodnik dla początkujących i zaawansowanych.",
  "articles_section.title": "Artykuły i poradniki Kakobuy Spreadsheet",
  "articles_section.subtitle": "Poznaj nasze szczegółowe przewodniki, porównania i porady zakupowe",
  "cta.title": "Gotowy, aby znaleźć najlepsze produkty?",
  "cta.subtitle": "Dołącz do tysięcy zadowolonych użytkowników Kakobuy Spreadsheet i odkryj świat niesamowitych finds już dziś.",
  "cta.button": "Przejdź do Kakobuy Spreadsheet",
  "testimonial.title": "Co mówią nasi użytkownicy",
  "testimonial.quote": "Kakobuy Spreadsheet całkowicie zmienił sposób, w jaki robię zakupy. Zamiast spędzać godziny na szukaniu produktów, mam wszystko w jednym miejscu. Polecam każdemu!",
  "testimonial.author": "Anna K., Warszawa",
  "footer.description": "KakobuyFinds to niezależny przewodnik po Kakobuy Spreadsheet dla polskich użytkowników. Znajdziesz tu najlepsze finds, linki produktów i poradniki zakupowe.",
  "footer.quick_links": "Szybkie linki",
  "footer.categories_footer": "Kategorie",
  "footer.resources": "Zasoby",
  "footer.privacy": "Polityka prywatności",
  "footer.disclaimer": "Zastrzeżenie",
  "footer.contact": "Kontakt",
  "footer.copyright": "© 2026 KakobuyFinds. Wszelkie prawa zastrzeżone.",
};

export default common;